import { Button, ButtonGroup, Flex, FlexProps, Text } from '@chakra-ui/react';
import { Table } from '@tanstack/react-table';
import { useSearchParams } from 'react-router-dom';

import { PageInfo } from '@/@generated/codegen/API';
import { QUERY_PARAM_PAGE_INDEX_KEY } from '@/hooks/usePaginationState';
import { getPrefixedQueryParamKey } from '@/hooks/useQueryParams';

type Props<TData> = {
  table: Table<TData>;
  pageInfo: PageInfo;
  totalRows: number;
  tablePrefix: string;
} & Omit<FlexProps, 'table'>;

function Pagination<TData>({
  table,
  pageInfo,
  totalRows,
  tablePrefix,
  ...flexProps
}: Props<TData>) {
  const [searchParams, _] = useSearchParams();
  const currPageIndex = +(
    searchParams.get(getPrefixedQueryParamKey(QUERY_PARAM_PAGE_INDEX_KEY, tablePrefix)) || 0
  );

  return (
    <Flex gap="10px" alignItems="center" justifyContent="space-between" {...flexProps}>
      <ButtonGroup size="sm" isAttached variant="outline">
        {/* <Button
          onClick={() => table.setPageIndex(Math.max(table.getState().pagination.pageIndex - 5, 0))}
          isDisabled={!table.getCanPreviousPage()}
          variant="primary"
        >
          {'<<'}
        </Button> */}

        <Button
          onClick={() => table.previousPage()}
          isDisabled={!pageInfo.hasPreviousPage}
          variant="primary"
        >
          {'<'}
        </Button>
      </ButtonGroup>

      <Text noOfLines={1}>
        Page {currPageIndex + 1} / {table.getPageCount()} ({totalRows || 0} rows)
      </Text>
      <ButtonGroup size="sm" isAttached variant="outline">
        <Button
          onClick={() => table.nextPage()}
          isDisabled={!pageInfo.hasNextPage}
          variant="primary"
        >
          {'>'}
        </Button>
        {/* <Button
          variant="primary"
          isDisabled={!table.getCanNextPage()}
          onClick={() =>
            table.setPageIndex(
              Math.min(table.getState().pagination.pageIndex + 5, table.getPageCount() - 1)
            )
          }
        >
          {'>>'}
        </Button> */}
      </ButtonGroup>
    </Flex>
  );
}

export default Pagination;
